module.exports = __webpack_public_path__ + "static/Lich-28f496e6920991bf99b63af53f24f117.jpg";